<template>
  <div class="public">
    <b-navbar type="light" class="header" toggleable="md">
      <b-container>
        <b-navbar-toggle target="nav_collapse" />
        <b-navbar-brand href="/" class="pnud-logo-sm">
          <img
            :src="'/static/images/unpd/unpd_logo_color_' + lang + '.svg'"
            height="80"
          />
        </b-navbar-brand>
      </b-container>
    </b-navbar>
    <router-view />
    <b-navbar type="light" class="footer" toggleable="md">
      <b-col md="6" offset-md="3">
        <b-row >
          <b-col cols="9">
            <b-navbar-nav class="ml-auto">
              <b-nav-item v-b-modal.termsOfUse>
                {{ $t("landing_footer_termsOfUse_caption") }}
              </b-nav-item>
              <b-nav-item v-b-modal.privacyPolicy>
                {{ $t("landing_footer_privacy_caption") }}
              </b-nav-item>
              <b-nav-item>{{ $t("landing_footer_copyright_caption") }}</b-nav-item>
            </b-navbar-nav>
          </b-col>
          <b-col cols="3">
            <b-navbar-nav class="social-media">
            <b-nav-item href="https://www.facebook.com/PNUD/" target="_blank">
                <img
                  width="50"
                  src="/static/images/social_media/icon_facebook.png"
                  class="button"
                />
              </b-nav-item>
              <b-nav-item
                href="https://www.flickr.com/photos/138133267@N05/"
                target="_blank"
              >
                <img width="50" src="/static/images/social_media/icon_flickr.png"
                class="button" 
                />
              </b-nav-item>
              <b-nav-item
                href="https://twitter.com/pnud_algenera?lang=es"
                target="_blank"
              >
                <img
                  width="50"
                  src="/static/images/social_media/icon_twitter.png"
                  class="button"
                />
              </b-nav-item>
              <b-nav-item
                href="https://www.youtube.com/playlist?list=PLBA953D25DB561FD7"
                target="_blank"
              >
                <img
                  width="50"
                  src="/static/images/social_media/icon_youtube.png"
                  class="button"
                />
              </b-nav-item>
            </b-navbar-nav>
          </b-col>
        </b-row>
      </b-col>
    </b-navbar>
    <b-modal id="termsOfUse" size="lg">
      <div v-html="$t('terms_of_use')" />
      <div slot="modal-footer" />
    </b-modal>
    <b-modal id="privacyPolicy" size="lg">
      <div v-html="$t('privacy_policy')" />
      <div slot="modal-footer" />
    </b-modal>
    <b-modal v-model="showErrorsModal" no-close-on-esc no-close-on-backdrop>
      <template #modal-header="">
        <h5>{{$t('label_errorsNotifications_sessionFinished_title')}}</h5>
      </template>
      <div>
        {{$t('label_errorsNotifications_sessionFinished')}}
      </div>
      <ul>
        <li v-for="(error, errorIndex) of getAllErrors" :key="errorIndex">
          {{ error }}
        </li>
      </ul>
      <template #modal-footer="">
        <b-button size="sm" variant="primary" @click="dismissErrors()">
          Cerrar
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="getTokenExpired" no-close-on-esc no-close-on-backdrop>
      <template #modal-header="">
        <h5>{{ label_sessionExpired_warning_title }}</h5>
      </template>
      <div>{{ label_sessionExpired_warning_mainMessage }}</div>
      <template #modal-footer="">
        <b-button variant="primary" @click="dissmissExpiration()">
          {{ label_sessionExpired_warning_login_button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      route: "",
      label_sessionExpired_warning_title: "",
      label_sessionExpired_warning_mainMessage: "",
      label_sessionExpired_warning_login_button: "",
      showErrorsModal: false,
    };
  },
  watch: {
    $route(to) {
      this.route = to;
    },
    getAllErrors: {
      handler: function () {
        this.showErrorsModal = this.getAllErrors.length > 0;
      },
      deep: true,
    },
  },
  computed: {
    lang() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.label_sessionExpired_warning_title = this.$t(
        "label_sessionExpired_warning_title"
      );
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.label_sessionExpired_warning_mainMessage = this.$t(
        "label_sessionExpired_warning_mainMessage"
      );
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.label_sessionExpired_warning_login_button = this.$t(
        "label_sessionExpired_warning_login_button"
      );
      return this.$i18n.locale;
    },
    ...mapGetters(["getTokenExpired", "getAllErrors"]),
  },
  mounted() {
    this.showErrorsModal = this.getAllErrors.length > 0;
    this.$store.dispatch("USERACCOUNTS_LOGOUT");
    this.cMounted = true;
  },
  methods: {
    dismissErrors() {
      this.$store.dispatch("dismissAllErrors");
    },
    dissmissExpiration() {
      this.$store.commit("setTokenExpired", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/*  containers/Public */

@import '../assets/css/variables.scss';

.public {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f4fafd;
  .header {
    text-transform: uppercase;
  }
  .navbar {
    height: 90px;
    padding: 15px;
    font-size: 1.2rem;
    font-family: $font-subtitle-light;
    #nav_collapse {
      height: 90px;
    }
    .navbar-nav {
      height: 100%;
      li {
        padding-top: 20px;
      }
      .login {
        background-color: #e7e7ec;
      }
    }
    .fa-icon {
      position: relative;
    }
    .pnud-logo {
      margin: 0px;
    }
    .pnud-logo-sm {
      display: none;
    }
  }
  .footer {
    font-size: 1rem;
    .social-media {
      margin-left: 5px;
      .button{
        margin-top: -5px;
        margin-right: 4px;
        filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
      }
      a {
        padding: 0;
      }
    }
  }
}
@media (max-width: 576px) {
  .public {
    .navbar {
      height: 100%;
      .pnud-logo-sm {
        display: initial;
        img {
          height: 50px;
        }
      }
      .pnud-logo {
        display: none;
      }
      .indica-logo {
        height: 50px;
      }
      .navbar-nav {
        li {
          padding-top: 0px;
        }
        .login {
          background-color: inherit;
        }
      }
    }
  }
  .footer {
    .social-media img {
      height: 60px;
    }
    .navbar-nav {
      margin-left: unset !important;
    }
  }
};
</style>
